<template>
<div>
    <ToastMe />
    <CElementCover :opacity="0.8" style="z-index:100" v-show="!is_current_fetched" />
    <router-view v-if="checkSetup()"></router-view>
</div>
</template>

<script>
import { ToastMe } from '@/components'
import { mapGetters } from 'vuex'
import { UserSetupStatus } from '@/constants'

export default {
    name: 'App',

    components: {
        ToastMe,
    },

    computed: {
        ...mapGetters({
            user: 'user/current',
            is_current_fetched: 'user/is_current_fetched'
        })
    },

    methods: {
        checkSetup() {
            if (this.$route.name === 'callback') {
                return true
            }

            const storeRoutes = [
                'setup.steps.store_information',
                'setup.steps.implement_script',
                'setup.steps.set_commission',
                'setup.steps.charge_account',
            ]

            const setupStatuses = {
                [UserSetupStatus.PERSONAL_INFO]: 'setup.steps.personal_information',
                [UserSetupStatus.FINANCIAL_INFO]: 'setup.steps.financial_information',
                [UserSetupStatus.MEDIA]: 'setup.steps.submit_media',
                [UserSetupStatus.ACTIVITY_AREA]: 'setup.steps.submit_activity_area',
                [UserSetupStatus.STORE_INFO]: 'setup.steps.store_information',
                [UserSetupStatus.IMPLEMENT_SCRIPT]: 'setup.steps.implement_script',
                [UserSetupStatus.SUBMIT_COMMISSION]: 'setup.steps.set_commission',
                [UserSetupStatus.CHARGE_ACCOUNT]: 'setup.steps.charge_account',
                [UserSetupStatus.ACCEPT_AGREEMENT]: 'setup.steps.accept_agreement',
                [UserSetupStatus.PENDING_TO_ACTIVE]: 'setup.steps.finish',
                [UserSetupStatus.SUSPENDED]: 'setup.steps.suspended',
            }

            if (this.$route.name && ['setup.tickets', 'setup.tickets.create', 'setup.tickets.details'].includes(this.$route.name)) {
                return true
            }

            if (this.$route.name && this.user.setup_status !== UserSetupStatus.COMPLETE) {
                if (setupStatuses[this.user.setup_status]) {
                    if (this.$route.name !== setupStatuses[this.user.setup_status]) {
                        this.$router.push({name: setupStatuses[this.user.setup_status]})
                    }
                } else {
                    this.$router.push({name: setupStatuses[UserSetupStatus.PERSONAL_INFO]})
                }
            }
            else if (this.$route.name && this.$policy('store').join && storeRoutes.includes(this.$route.name)) {
                this.$router.push({name: 'dashboard'})
            }
            else if (this.$route.name && this.$route.name.includes('setup') && this.user.setup_status === UserSetupStatus.COMPLETE) {
                this.$router.push({name: 'dashboard'})
            }

            return true
        }
    },
}
</script>

<style lang="scss">
    @import "@/assets/scss/style";
</style>